import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { OrderPipe } from 'ngx-order-pipe';
import { Insomnia } from '@ionic-native/insomnia/ngx';

// import Diaporama from 'diaporama';

// declare var diaporama: any;
// import * as diaporama from 'diaporama';
// import * as GlslTransitions from 'glsl-transitions';
// const data = require('./diaporama.json');
// import * as ns from "mod"
// const Diaporama = require('diaporama');
// const GlslTransitions = require('glsl-transitions');

@Component({
  selector: 'app-visualization',
  templateUrl: './visualization.page.html',
  styleUrls: ['./visualization.page.scss'],
})
export class VisualizationPage implements OnInit {
  // @ViewChild('slider', { read: ElementRef })slider: ElementRef;
  public images: any;
  sliderOpts = {
    autoplay: true,
    zoom: {
      maxRatio: 5
    }
  };
  public userId: any;

  constructor(
    private insomnia: Insomnia,
    private router: Router,
    public afAuth: AngularFireAuth,
    public modalController: ModalController,
    public afDB: AngularFireDatabase,
    public afSG: AngularFireStorage,
    private orderPipe: OrderPipe
    ) {
      this.insomnia.keepAwake()
      .then(
        () => console.log('insomnia success'),
        () => console.log('insomnia error')
      );
      // const data = require('./diaporama.json');
      // data.transitions = GlslTransitions;
      // // tslint:disable-next-line:prefer-const
      // let diaporama = Diaporama(document.getElementById('diaporama'), data, {
      //   autoplay: true,
      //   loop: true
      // });
      // function resize() {
      //   // Responsive diaporama
      //   const width = Math.min(800, document.body.clientWidth);
      //   const height = Math.round(0.75 * width);
      //   diaporama.width = width;
      //   diaporama.height = height;
      // }
      // window.addEventListener('resize', resize);
      // resize();
      // window.diaporama = diaporama; // Play with diaporama in the Web Console
    }

  ngOnInit() {
    this.afAuth.authState.subscribe(auth => {
      if (!auth) {
        console.log('non connecté');
        this.router.navigateByUrl('/login');
      } else {
        console.log('Connecté: ' + auth.uid);
        this.userId = auth.uid;
        this.getImages();
      }
    });
  }

  getImages() {
    const imageRef = this.afDB.list('Visualisations/' + this.userId);
    imageRef.snapshotChanges(['child_changed', 'child_added', 'child_removed'])
    .subscribe(actions => {
      const that = this;
      const data = [];
      let count = 0;
      actions.forEach((action: any) => {
        that.afSG.ref(action.payload.val().imgUrl).getDownloadURL().subscribe(postUrl => {
          if (action.payload.val().order === '') {
            data.push({
              url: postUrl,
              key: action.payload.key,
              order: count
            });
            console.log(postUrl);
            this.images = this.orderPipe.transform(data, 'order');
          } else {
            data.push({
              url: postUrl,
              key: action.payload.key,
              order: action.payload.val().order
            });
            console.log('data: ' + data[count]);
            this.images = this.orderPipe.transform(data, 'order');
          }
          count++;
        });
        // this.images = data;
      });
    });
  }

  async closeModal() {
    this.modalController.dismiss();
  }

  slidesDidLoad(slides) {
    slides.startAutoplay();
  }
}
